import { useApolloClient } from '@apollo/client'
import { CompleteEmployeelifecycleStepActionDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

import {
  readTaskFromCache,
  useMarkTaskAsDoneInCache,
  writeTaskToCache,
} from 'modules/inbox_tasks/lib/markTaskAsDoneInCache'

type CompleteStepActionTaskParams = {
  stepActionId: string
  taskId: string
}

export const useCompleteStepActionTask = () => {
  const apolloClient = useApolloClient()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const [completeStepActionTask] = useMutation(CompleteEmployeelifecycleStepActionDocument, {
    extractorFn: (data) => data.employeeLifecycleMutations.completeEmployeelifecycleStepAction,
  })

  const markTaskAsDoneInCache = useMarkTaskAsDoneInCache()

  return async ({ stepActionId, taskId }: CompleteStepActionTaskParams) => {
    const previousTaskData = readTaskFromCache(apolloClient, taskId)

    markTaskAsDoneInCache(taskId)

    try {
      await completeStepActionTask({
        variables: {
          companyId,
          id: stepActionId,
        },
      })
    } catch (error) {
      if (previousTaskData) {
        writeTaskToCache(apolloClient, taskId, previousTaskData)
      }

      throw error
    }
  }
}
